export default "__VITE_ASSET__DaXtVUax__"